module.exports = __webpack_public_path__ + "874560e797948d2d919a658538151b9c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/painted-nails-pink.png
// module id = 2520
// module chunks = 0